import { AUTH_USER, AUTH_ERROR, SEARCHBAR, SEARCHBARSTYLE, DEVICE, DRIVERERROR, DRIVERERRORCLEAN } from '../actions/types';
import uniqid from 'uniqid';

// this will set the intial state of the app in redux store. 
const INTIAL_STATE = {
  authenticated: '',
  errorMessage: '',
  searchBarShow: false,
  searchBarStyle: 'animatedee animated-duration-custom slideInDown pb-3',
  deviceApi: [
    {
      paramField: 'SampleAPI',
      paramUniqueKey: uniqid(),
      paramValues: {
        key: uniqid(),
        value: [
          {
            value: '',
            key: uniqid(),
          }, {
            value: '',
            key: uniqid(),
          }],
        path: 'root',
        valueType: 'type1'
      }
    }
  ],
  deviceDriverError: [] 
}

export default function (state = INTIAL_STATE, action) {
  switch (action.type) {
    case AUTH_USER:
      return { ...state, authenticated: action.payload };
    case AUTH_ERROR:
      return { ...state, errorMessage: action.payload };
    case SEARCHBAR:
      return { ...state, searchBarShow: action.data };
    case SEARCHBARSTYLE:
      return { ...state, searchBarStyle: action.data };
    case DEVICE:
      return { ...state, deviceApi: action.data };
    case DRIVERERROR:
      return { ...state, deviceDriverError: action.data };
    case DRIVERERRORCLEAN:
      return { ...state, deviceDriverError: action.data };
  }
  return state;
}
